<div class="bg-light-grey lg:p-7">
	<div
		class="flex flex-col gap-5 lg:py-[36px] lg:px-[48px] bg-off-white rounded-12px lg:w-[880px] m-auto"
	>
		<div
			*ngIf="missingDataArray.length > 0"
			class="bg-[#181A26] px-[16px] inline-block rounded-[4px] mb-[5px] m-auto"
		>
			<h1 class="text-off-white text-font-14 inline-block m-0">
				{{ 'SERVICE.SERVICES_LIST.MUST_ADD' | translate }}
				<span *ngFor="let sectionName of missingDataArray">
					{{ 'SERVICE.SERVICES_LIST.' + sectionName | translate }}
				</span>
				<span>{{
					'SERVICE.SERVICES_LIST.TO_ACTIVATE_BRANCH' | translate
				}}</span>
			</h1>
			<img
				class="inline-block"
				src="./assets/images/yellow-danger.svg"
				alt=""
			/>
		</div>
		<!-- slider -->
		<app-organization-branch-slider
			[branchInformationData]="branchInformationData"
			(updateData)="getBranchInformation()"
		></app-organization-branch-slider>
		<!-- basic information -->
		<app-organization-branch-basic-info
			[type]="type"
			[branchInformationData]="branchInformationData"
			(dataChanged)="getBranchInformation()"
		></app-organization-branch-basic-info>
		<!-- contact information -->
		<app-organization-branch-contact-info
			[branchInformationData]="branchInformationData"
			(dataChanged)="getBranchInformation()"
		></app-organization-branch-contact-info>
		<!-- target audience -->
		<app-organization-branch-target-audience
			[branchInformationData]="branchInformationData"
		></app-organization-branch-target-audience>
		<!-- store information -->
		<ng-container *ngIf="type == 2">
			<app-store-profile-information></app-store-profile-information>
		</ng-container>
		<ng-container *ngIf="type == 2">
			<!-- delivery information -->
			<app-store-profile-delivery-info
				[branchInformationData]="branchInformationData"
			></app-store-profile-delivery-info>
		</ng-container>

		<!-- location -->
		<app-organization-branch-location
			*ngIf="type == 1"
			[branchInformationData]="branchInformationData"
			(dataChanged)="getBranchInformation()"
		></app-organization-branch-location>
		<!-- working hours -->
		<div
			*ngIf="workingHoursEdit && type == 1"
			class="overlay bg-black opacity-30 fixed top-0 left-0 w-screen h-screen z-30"
		></div>

		<div
			*ngIf="type == 1"
			class="flex flex-row justify-between mt-4 min-h-[40px]"
		>
			<p class="text-[#1C252E] font-medium text-base leading-5 m-0">
				{{ 'ORGANIZATION.BRANCH.WORKING_HOURS' | translate }}
			</p>
			<div
				*ngIf="!workingHoursEdit && type == 1"
				(click)="workingHoursEdit = !workingHoursEdit"
				class="flex gap-1 ltr:mr-6 rtl:ml-6 hover:cursor-pointer"
			>
				<img class="w-5 max-h-5" src="assets/images/edit-blue.svg" alt="" />
				<p class="text-[#009EF7]">{{ 'ACTIONS.EDIT' | translate }}</p>
			</div>
		</div>
		<div
			*ngIf="type == 1"
			class="{{
				workingHoursEdit ? 'z-40' : ''
			}} relative bg-off-white p-24px rounded-12px shadow-default"
		>
			<app-working-hours
				[branchId]="branchInformationData?.id"
				[workingHours]="branchInformationData?.workingHours || []"
				[editMode]="workingHoursEdit"
				(dataChanged)="workingHoursData = $event"
				(inValid)="workingHouresInvalid = $event"
			></app-working-hours>
			<div *ngIf="workingHoursEdit" class="flex mt-24px justify-end">
				<button
					(click)="workingHoursEdit = !workingHoursEdit; getBranchInformation()"
					class="border border-solid text-dark-grey border-[#D9DBE9] hover:bg-gradient hover:text-off-white mx-2"
					mat-button
				>
					{{ 'ACTIONS.CANCEL' | translate }}
				</button>
				<button
					(click)="update(); getBranchInformation()"
					class="bg-gradient text-off-white rounded"
					mat-button
					[disabled]="workingHouresInvalid"
				>
					{{ 'ACTIONS.SAVE' | translate }}
				</button>
			</div>
		</div>
		<!-- settings -->
		<app-organization-branch-settings
			*ngIf="type == 1"
			[branchInformationData]="branchInformationData"
		></app-organization-branch-settings>
		<!-- social accounts -->
		<div *ngIf="branchInformationData">
			<app-organization-branch-social-accounts
				[branchInformationData]="branchInformationData"
			></app-organization-branch-social-accounts>
		</div>
	</div>
</div>
